import { createStore } from 'vuex'
import { auth } from './auth.module'
import { configModule } from './config.module'
import { STORAGE_KEYS } from '@/config/constants'

const store = createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    config: configModule,
  },
})

// Синхронизация выбранного города между вкладками: localStorage у вкладок
// общий, а состояние Vuex — своё у каждой. Вкладка, где город сменили,
// пишет localStorage — остальные ловят событие storage и обновляют свой
// стор (иначе шапка в другой вкладке показывала старый город).
window.addEventListener('storage', (e) => {
  if (e.key === STORAGE_KEYS.SELECTED_CITY) {
    store.commit('config/SET_SELECTED_CITY_ID', e.newValue ? parseInt(e.newValue) : null)
  }
})

export default store
